import parse from "html-react-parser";
import { forwardRef } from "react";
import { useSelector } from "react-redux";

import { CustomReviewEstimateTable } from "../ReviewEsimateSheetTable";
import { useReviewSheet } from "../ReviewSheetContext";

import footerImg from "@/assets/images/footerImg.png";
import defaultLogo from "@/assets/images/headerImg.png";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { cn, renderFullName } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { dateFormat } from "@/utils/helper-functions/date-time.helper";

export const PreviewPDFEstimateReview = forwardRef<HTMLDivElement>((_, ref) => {
  const { selectedData, itemsList, letterHead, originalData } =
    useReviewSheet();
  const userData = useSelector((state: RootState) => state.user?.userData);

  return (
    <div id='formatToPrint' className='my-4 ' ref={ref}>
      <div id='docketExportDetails' className='border shadow-md overflow-clip '>
        {letterHead?.headerActive && (
          <div className='border-b'>
            <img
              src={letterHead?.headerImage || defaultLogo}
              alt='formatLogo'
              className={cn(`w-full object-fill`, "h-[125px]")}
              style={{ opacity: letterHead?.headerOpacity }}
            />
          </div>
        )}
        <div className='px-4 mt-4 space-y-6 '>
          <h1 className='text-base'>Strip-Out/Demolition Quote</h1>
          <div className='p-2 border rounded-sm '>
            <div className='grid grid-cols-2 '>
              <div>
                <div className=' flex gap-[3.8rem] py-2 border-b'>
                  <h1 className='text-sm'>ATTN</h1>
                  <p className='text-sm text-gray-400'>
                    {originalData?.lead?.customerUsers?.[0]?.user?.firstName}
                  </p>
                </div>
                <div className='flex py-2 border-b gap-14'>
                  <h1 className='text-sm'>Client</h1>
                  <p className='text-sm text-gray-400'>
                    {originalData?.lead?.customer?.name}
                  </p>
                </div>
                <div className='flex gap-10 py-2 '>
                  <h1 className='text-sm'>Address</h1>
                  <p className='text-sm text-gray-400'>
                    {originalData?.lead?.address?.areaLocation}
                  </p>
                </div>
              </div>
              <div>
                <div className='flex gap-16 py-2 border-b '>
                  <h1 className='text-sm'>Our Ref</h1>
                  <p className='text-sm text-gray-400'>
                    {originalData?.lead?.referenceNumber}
                  </p>
                </div>
                <div className=' flex gap-[5.2rem] py-2 border-b'>
                  <h1 className='text-sm'>Date</h1>
                  <p className='text-sm text-gray-400'>
                    {dateFormat(originalData?.submittedDate, "dd/MM/yyyy")}
                  </p>
                </div>
                <div className=' flex gap-[3.6rem] py-2 '>
                  <h1 className='text-sm'>Property</h1>
                  <p className='text-sm text-gray-400'>
                    {originalData?.lead?.address?.label}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <CustomReviewEstimateTable
            data={selectedData?.mainCost || []}
            itemsList={itemsList}
            isExport
          />
          {selectedData?.additionalCost?.length !== 0 ? (
            <CustomReviewEstimateTable
              data={selectedData?.additionalCost || []}
              itemsList={itemsList}
              isExport
              isOptional
            />
          ) : (
            <Table>
              <TableHeader>
                {Array?.from({ length: 5 }, (_, i) => (
                  <TableCell key={i}></TableCell>
                ))}
              </TableHeader>
              <TableBody className='border'>
                <TableRow>
                  <TableCell className='border '>
                    Additional Option Cost Ex GST
                  </TableCell>
                  {Array?.from({ length: 4 }, (_, i) => (
                    <TableCell className='border ' key={i}></TableCell>
                  ))}
                </TableRow>
              </TableBody>
            </Table>
          )}
        </div>
        <div className='flex items-center mt-3 '>
          <span className='px-3 '>Remarks:</span>
          <div className='flex-col '>{parse(originalData?.review ?? "")}</div>
        </div>
        <div className='flex flex-col gap-1 mt-3 ml-3 '>
          <h2>Your Sincerely,</h2>
          <div>
            <p className=''>
              Name{" "}
              <span className='text-gray-500'>
                {renderFullName({ userData })}
              </span>
            </p>
            <p>
              Role <span className='ml-3 text-gray-500'>{userData?.role}</span>
            </p>
          </div>
        </div>
        {letterHead?.footerActive && (
          <img
            src={letterHead?.footerImage || footerImg}
            alt='footer'
            className={cn(`w-full `, "h-[135px]")}
            style={{ opacity: letterHead?.footerOpacity }}
          />
        )}
      </div>
    </div>
  );
});

PreviewPDFEstimateReview.displayName = "PreviewPDFEstimateReview";
